import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Content, ToastController, AlertController, LoadingController, Loading, ModalController, } from 'ionic-angular';
import { CustomerSearchModel } from '../../models/sap/customersearch.model';
import { SalesAreaModel } from '../../models/sap/salesarea.model';
import * as _ from "lodash";
import { UtilService } from '../../services/util.service';
import { Storage } from '@ionic/storage';
import { CustomerService } from '../../services/customer.service';
import { StorageService } from '../../services/storage.service';
import { SoldToModel } from 'models/sap/soldto.model';
import { ShipToModel } from 'models/sap/shipto.model';
import { PayerModel } from 'models/sap/payer.model';
import { CustomerSubmitModel } from '../../models/sap/customersubmit.model';
import { CustomerSalesAreaModel } from '../../models/sap/customersalesarea.model';
import { Setups } from '../../services/setup';
import { Page } from '../../enums/page.enum';
import { ModalAction } from '../../enums/modalaction.enum';

@IonicPage()
@Component({
  selector: 'customer-search',
  templateUrl: 'customer-search.html',
})
export class CustomerSearchPage implements OnInit {
  @ViewChild('foot') elementView: ElementRef;
  @ViewChild(Content) content: Content;
  customerSearch: CustomerSearchModel;
  customerSearchHolder: CustomerSearchModel;
  customerSubmit: CustomerSubmitModel;
  currentSalesRepCode: string;
  salesAreas: SalesAreaModel[];
  soldToCustomers: SoldToModel[];
  shipToCustomers: ShipToModel[];
  payerCustomers: PayerModel[];
  loading: Loading;
  isAllowAdhocCustomerInsertion: Boolean = false;
  isDisableShipToCustomers: Boolean = false;
  isDisablePayerCustomers: Boolean = false;

  constructor(public navCtrl: NavController
    , public navParams: NavParams
    , private loadingCtrl: LoadingController
    , private alertCtrl: AlertController
    , private util: UtilService
    , private customerService: CustomerService
    , private storage: Storage
    , private storageService: StorageService
    , private modalCtrl: ModalController
    , private toastCtrl: ToastController
    , private setups: Setups) {
      this.customerSearch = new CustomerSearchModel();
      this.customerSearchHolder = new CustomerSearchModel();
      this.customerSubmit = new CustomerSubmitModel();
  }

  async ngOnInit() {
    await this.storage.get('user').then((user) => {
      this.currentSalesRepCode = user.salesrep_list[0].salesrep_code;
      this.isAllowAdhocCustomerInsertion = user.setup_list.some(r => r.setup_code === this.setups.AllowAdhocCustomerInsertion.ID);
    });

    if (this.isAllowAdhocCustomerInsertion === false) {
      this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, "Access denided",
                                                        "You don't have permission to access to page. Please contact administrator for support.", Page.CustomerList);
    } else {
        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading data");
        // Calling web service to fetch sales area
        await this.customerService.retrieveSalesAreaBySalesrepCode(this.currentSalesRepCode , this.storageService.getSettingId()).subscribe(
          (res) => {
            if (_.isEmpty(res.data)) {
              this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, "Sales area missing",
                                                        "Sales area has not been updated for this salesrep in SAP. Please check", Page.CustomerList);
            } else {
              this.salesAreas = res.data;
              let modalSalesAreaList: CustomerSalesAreaModel[] = new Array();
              for (let index = 0; index < res.data.length; index++) {
                let model: CustomerSalesAreaModel = new CustomerSalesAreaModel();
                model.SalesOrg = res.data[index].SalesAreaValue.split(',')[0]
                model.Division = res.data[index].SalesAreaValue.split(',')[1]
                model.DistChannel = res.data[index].SalesAreaValue.split(',')[2]
          
                modalSalesAreaList.push(model);
              }
                
              let SalesAreaModal = this.modalCtrl.create('CustomerSalesAreaPage', { salesAreaList: modalSalesAreaList });
              SalesAreaModal.present();
              SalesAreaModal.onDidDismiss((data) => {
                if (!!data) {
                    if (!!data.action && data.action === ModalAction.Proceed) {
                      this.customerSearch.sales_area = data.selectedSalesArea.SalesOrg + ',' + data.selectedSalesArea.Division + ',' + data.selectedSalesArea.DistChannel
                    }
                }
              });
            }
          },(err) => {
            this.loading.dismiss();
            const errObj = JSON.parse(err._body)
            // display error
            this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
          },() => {
            // on complete
            this.loading.dismiss();
          });
    }
  }

  ionViewDidLoad() {

  }

  async onClickSearchButton() {
    // Validate input
    // User must input either sold to code or sold to name
    if (_.isEmpty(this.customerSearch.sold_to_code) && _.isEmpty(this.customerSearch.sold_to_name)) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Either Sold to Code or Sold to Name must be filled in before searching');
      return;
    }

    // User must input sales area
    if (_.isEmpty(this.customerSearch.sales_area)) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Please choose a sales area');
      return;
    }

    // Sold to code must be a number
    if (!_.isEmpty(this.customerSearch.sold_to_code) && !/^\d+$/.test(this.customerSearch.sold_to_code)) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Sold to code can only contain numbers.');
      return;
    }

    // Sold to code must be a 4 digits numbers
    if (!_.isEmpty(this.customerSearch.sold_to_code) && _.size(this.customerSearch.sold_to_code) < 4) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Sold to code must contains at least 4 numbers.');
      return;
    }

    // Sold to code can not be more than 20 numbers
    if (!_.isEmpty(this.customerSearch.sold_to_code) && _.size(this.customerSearch.sold_to_code) > 20) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Sold to code can not be more than 20 numbers.');
      return;
    }

    // Sold to name must contain at leats 6 characters
    if (!_.isEmpty(this.customerSearch.sold_to_name) && _.size(this.customerSearch.sold_to_name) < 4) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Sold to name must contains at least 4 characters.');
      return;
    }

    // Sold to name must contain at leats 6 characters
    if (!_.isEmpty(this.customerSearch.sold_to_name) && _.size(this.customerSearch.sold_to_name) > 50) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Sold to name can not be more than 50 characters.');
      return;
    }

    // Ship to code must be a number
    if (!_.isEmpty(this.customerSearch.ship_to_code) && !/^\d+$/.test(this.customerSearch.ship_to_code)) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Ship to code can only contain numbers.');
      return;
    }

    // Ship to code must be a 4 digits number.
    if (!_.isEmpty(this.customerSearch.ship_to_code) && _.size(this.customerSearch.ship_to_code) < 4) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Ship to code must contains at least 4 numbers.');
      return;
    }

    // Ship to code must be a 4 digits number.
    if (!_.isEmpty(this.customerSearch.ship_to_code) && _.size(this.customerSearch.ship_to_code) > 20) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Ship to code can not be more than 20 numbers.');
      return;
    }

    // Ship to name must contains at least 6 characters
    if (!_.isEmpty(this.customerSearch.ship_to_name) && _.size(this.customerSearch.ship_to_name) < 4) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Ship to name must contains at least 4 characters.');
      return;
    }

    // Ship to name must contains at least 6 characters
    if (!_.isEmpty(this.customerSearch.ship_to_name) && _.size(this.customerSearch.ship_to_name) > 50) {
      this.util.displayAlert(this.alertCtrl, 'Search criteria', 'Ship to name  can not be more than 50 characters.');
      return;
    }

    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading customer data");

    // Calling web service
    await this.customerService.retrieveCustomerListFromSAP(
      this.customerSearch.sold_to_code
      , this.customerSearch.sold_to_name
      , this.customerSearch.ship_to_code
      , this.customerSearch.ship_to_name
      , this.currentSalesRepCode
      , this.customerSearch.sales_area
      , this.storageService.getSettingId()).subscribe(
      async (res) => {
        if (_.isEmpty(res.data)) {
          this.util.displayAlert(this.alertCtrl, "Info", "There is no data available or this customer has already exists. Please check on customer page.");
        } else {
          this.customerSubmit.sold_to_code = '';
          this.customerSubmit.ship_to_code = '';
          this.customerSubmit.payer_code = '';
          this.customerSubmit.sales_area = this.customerSearch.sales_area

          this.soldToCustomers = res.data;
          // save search criteria, prevent user change criteria while choosing dropdown list of sold to, ship to, payer
          this.customerSearchHolder = JSON.parse(JSON.stringify(this.customerSearch))
        }
      },(err) => {
        this.loading.dismiss();
        const errObj = JSON.parse(err._body)
        // display error
        this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
      },() => {
        // on complete
        this.loading.dismiss();
      });
  }

  clearSearchCriteria() {
    this.customerSubmit.sold_to_code = '';
    this.customerSubmit.ship_to_code = '';
    this.customerSubmit.payer_code = '';
  }

  async submitCustomer() {
    if (_.isEmpty(this.customerSubmit.sold_to_code)) {
      this.util.displayAlert(this.alertCtrl, 'Information', 'You must choose a sold to party');
      return;
    }

    if (_.isEmpty(this.customerSubmit.ship_to_code)) {
      this.util.displayAlert(this.alertCtrl, 'Information', 'You must choose a ship to party');
      return;
    }

    if (_.isEmpty(this.customerSubmit.payer_code)) {
      this.util.displayAlert(this.alertCtrl, 'Information', 'You must choose a payer');
      return;
    }

    let soldToMsg = '<br />' + '<p class="alert-title">Sold to</p>' + this.soldToCustomers.filter(r => r.CustomerId === this.customerSubmit.sold_to_code)[0].CustomerName + '<br /><br />';
    let shipToMsg = '<p class="alert-title">Ship to</p>' + this.shipToCustomers.filter(r => r.ShipToCode === this.customerSubmit.ship_to_code)[0].ShipToName + '<br /><br />';
    let payMsg = '<p class="alert-title">Payer</p>' + this.payerCustomers.filter(r => r.PayerCode === this.customerSubmit.payer_code)[0].PayerName + '<br /><br />';
    let salesArea = '<p class="alert-title">Sales Org</p>' + this.salesAreas.filter(r => r.SalesAreaValue === this.customerSubmit.sales_area)[0].SalesAreaName + '<br /><br />';

    let msg = soldToMsg + shipToMsg + payMsg + salesArea;

    let arrButtons = [{ text: 'Cancel', role: 'cancel', handler: () => { return true; } },
        {
            text: 'Confirm', handler: async () => {
              this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Saving customer");

              this.customerSubmit.setting_id = this.storageService.getSettingId();
              this.customerSubmit.salesrep_code = this.currentSalesRepCode;
              this.customerSubmit.storage_location = this.salesAreas.filter(r => r.SalesAreaValue === this.customerSubmit.sales_area)[0].storage_location
              this.customerSubmit.plant = this.salesAreas.filter(r => r.SalesAreaValue === this.customerSubmit.sales_area)[0].plant
              // Calling web service to fetch sales area
              await this.customerService.saveCustomer(this.customerSubmit).subscribe(
                (res) => {
                  this.util.displayToast(this.toastCtrl, "Customer created");
                },(err) => {
                  this.loading.dismiss();
                  const errObj = JSON.parse(err._body)
                  // display error
                  this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
                },() => {
                  // on complete
                  this.loading.dismiss();
                });
            }
        }];

    this.util.displayConfirmation(this.alertCtrl, "Review customer details", msg, arrButtons);
  }

  async onChangeSoldTo(chosenSoldTo) {
    if (_.isEmpty(chosenSoldTo)) {
      return;
    }

    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading customer data");
    await this.customerService.retrieveCustomerMapping(chosenSoldTo, this.customerSearchHolder.ship_to_code, this.customerSearchHolder.ship_to_name, this.customerSearch.sales_area, this.storageService.getSettingId()).subscribe(
      (res) => {
        if (_.isEmpty(res.data.ShipToList) || _.isEmpty(res.data.PayerList)) {
          this.util.displayAlert(this.alertCtrl, "Error", "No data avaiable from SAP. Please check.");
          this.isDisablePayerCustomers = true;
          this.isDisableShipToCustomers = true;
        } else {
          this.shipToCustomers = res.data.ShipToList;
          this.payerCustomers = res.data.PayerList;
          this.isDisablePayerCustomers = false;
          this.isDisableShipToCustomers = false;
        }
      },(err) => {
        this.loading.dismiss();
        const errObj = JSON.parse(err._body)
        // display error
        this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
      },() => {
        // on complete
        this.loading.dismiss();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-search/customer-search.ts